export default __webpack_public_path__ + "72c4351fae599e7887dcb24dd6ef4538.png";